export default "__VITE_ASSET__DAyQBRPy__"